import { render, staticRenderFns } from "./column-check.vue?vue&type=template&id=467bca3e&"
import script from "./column-check.vue?vue&type=script&lang=js&"
export * from "./column-check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports